import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import {
  Input,
  Checkbox,
  Form,
  Button,
  Divider,
  Select,
  Radio,
  InputNumber,
} from "antd";
import ContentPadding from "../ContentConfig/ContentPadding";
import FormCustomIDField from "../ContentConfig/FormCustomIDField";
import { DEF_FONTS } from "../constanst";
import { ColorPickerFormItem } from "../Image/ImageConf";
import { useState } from "react";
import TrimmedInput from "../FormCommonField/FormTrimmedInput";

export default ({ node }) => {
  const defalutLabel = node?.data?.label || ""
  return (
    <>
      <Form.Item
        label="Label"
        name="label"
        rules={[{ required: true, max: 256 }]}
      >
        <TrimmedInput/>
        </Form.Item>
      <Form.Item name="hideLabel" valuePropName="checked">
        <Checkbox>Hide Label</Checkbox>
      </Form.Item>
      <FormCustomIDField />
      <Form.Item name="required" valuePropName="checked">
        <Checkbox>Required</Checkbox>
      </Form.Item>
      <Form.List name="options" label="Option">
        {(fields, { add, remove }, { errors }) => (
          <>
            {fields.map((field) => (
              <div
                key={field.name}
                style={{ display: "flex", alignItems: "baseline" }}
              >
                <Form.Item
                  {...field}
                  name={[field.name, "label"]}
                  style={{ width: "calc(100% - 60px)" }}
                >
                  <Input />
                </Form.Item>
                <Button
                  icon={<MinusOutlined />}
                  danger
                  size="small"
                  disabled={fields.length <= 1}
                  shape="circle"
                  type="primary"
                  style={{ marginTop: 5, marginLeft: 5 }}
                  onClick={() => remove(field.name)}
                />
              </div>
            ))}
            <Form.Item>
              <Form.ErrorList errors={errors} />
              <Button
                type="primary"
                style={{ width: "100%" }}
                onClick={() =>
                  add({ label: "New Options " + (fields.length + 1) })
                }
                icon={<PlusOutlined />}
              >
                Add Option
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>

      <strong>Style</strong>
      <Divider style={{ margin: "12px 0" }} />

      {/* Label settings group */}
      <div>
        <Form.Item
          label="Label horizon alignment"
          name="labelHorizonAlignment"
          initialValue={"start"}
        >
          <Radio.Group buttonStyle="solid">
            <Radio.Button value="start">Left</Radio.Button>
            <Radio.Button value="center">Center</Radio.Button>
            <Radio.Button value="end">Right</Radio.Button>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label="Label font size"
          name="labelFontSize"
          initialValue={14}
        >
          <InputNumber min={0} max={100} style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item
          label="Label default font"
          name="labelDefaultFont"
          initialValue={"arial"}
        >
          <Select showSearch options={DEF_FONTS} />
        </Form.Item>
        <ColorPickerFormItem
          label="Label font color"
          name="labelFontColor"
          color={node?.data?.labelFontColor || { r: 0, g: 0, b: 0, a: 1 }}
        />
      </div>

      <Divider style={{ margin: "12px 0" }} />
      <ContentPadding />
    </>
  );
};
